import { Dialog, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { EXTERNAL_LINKS } from '../../constants/links';

const SlidesDialog = ({ open, onClose }) => {
  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '80vw',
          height: '80vh',
          maxWidth: 'none',
          m: 0
        }
      }}
    >
      <IconButton
        sx={{ position: 'absolute', right: 8, top: 8, color: 'white', zIndex: 1 }}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
      <Box sx={{ position: 'relative', height: '100%' }}>
        <iframe
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 'none'
          }}
          src={`${EXTERNAL_LINKS.gameplay}/embed?start=false&loop=false&delayms=3000`}
          title="Gameplay Presentation"
          allowFullScreen
        />
      </Box>
    </Dialog>
  );
};

export default SlidesDialog; 